import { FC, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import MeasuredBy from "../molecules/MeasuredBy";
import { findBrandByDomain } from "../../configs/configLoader";
import { activeStylesContinue } from "../../configs";
import { hoverStylesContinue } from "../../configs/stylesLoader";
import { ArrowForward as ChevronRight } from "@mui/icons-material";
import { capitalizeFirstLetter } from "../../utils";

import "./index.css";

interface IPropsStepIntro {
  step: any;
  nextStep: () => void;
  descriptionStyles: {
    color: string;
    fontSize: React.CSSProperties["fontSize"];
    fontWeight: number;
    textAlign: React.CSSProperties["textAlign"];
    textTransform: React.CSSProperties["textTransform"];
    justifyContent: React.CSSProperties["justifyContent"];
    fontFamily: string;
    lineHeight: string;
    margin: string;
  };
}

const StepIntro: FC<IPropsStepIntro> = ({
  step,
  nextStep,
  descriptionStyles,
}) => {
  const { t } = useTranslation("components/device_select");

  const [hovered, setHovered] = useState(false);

  const brandDefined = findBrandByDomain();

  const isIntersport = brandDefined?.name === "Intersport";
  const isBlackstore = brandDefined?.name === "Blackstore";
  const isCustomBrands = isIntersport || isBlackstore;

  const mergedButtonStyles: React.CSSProperties = {
    ...(isCustomBrands ? activeStylesContinue : {}),
    ...(isIntersport && hovered ? hoverStylesContinue : {}),
    textTransform:
      descriptionStyles.textTransform as React.CSSProperties["textTransform"],
    marginBottom: "10px",
    position: "relative",
    padding: "16px",
    height: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
  };

  const arrowContainerStyle: React.CSSProperties = {
    display: "inline-block",
    width: hovered ? 16 : 0,
    overflow: "hidden",
    verticalAlign: "middle",
    transition: "width 160ms ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    opacity: hovered ? 1 : 0,
    transform: hovered ? "translateX(0)" : "translateX(-6px)",
    transition: "opacity 160ms ease, transform 160ms ease",
    display: "inline-block",
    verticalAlign: "middle",
    pointerEvents: "none",
  };

  return (
    <>
      <Box
        className="main-container"
        style={{
          margin: 0,
        }}
      >
        <span className="description" style={descriptionStyles}>
          {descriptionStyles.textTransform === "capitalize"
            ? capitalizeFirstLetter(t("intro.text"))
            : t("intro.text")}
        </span>

        <Box
          style={{
            marginTop: "35px",
            marginBottom: "36px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <video
            muted
            style={{
              minHeight: "210px",
              height: "210px",
              minWidth: "210px",
            }}
            playsInline
            autoPlay
            loop
          >
            <source
              src={
                "https://kleep-prod-assets-public.s3.eu-west-1.amazonaws.com/videos/Animation_Footwear.mp4"
              }
              type="video/mp4"
            />
          </video>
        </Box>

        <button
          type="button"
          className="continue-button"
          onClick={() => {
            nextStep();
          }}
          style={mergedButtonStyles}
          onMouseEnter={() => {
            setHovered(true);
          }}
          onMouseLeave={() => {
            setHovered(false);
          }}
        >
          <div style={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
            {t("intro.continue")}

            {isIntersport && (
              <span style={arrowContainerStyle} aria-hidden>
                <ChevronRight style={iconStyle} />
              </span>
            )}
          </div>
        </button>
      </Box>
      <MeasuredBy step={step} />
    </>
  );
};

export default StepIntro;
